/* Запазване на час: едно поле, стъпките една след друга.

   Антонио, 25.10.2026: „В едно цяло поле стъпките една след друга. Да не
   им дава да скролват надолу, не да избират да или не, при кой, дата,
   час. За да не могат да се шляят по страницата."

   И преди това, от Мила, след шест телефонни разговора за две почивни
   дни: „Изобщо не могат да се ориентират в сайта. Без капаро, с капаро,
   Мила, Грета, Христина, поддръжка наш клиент, поддръжка нов."

   ЗАЩО Е ОТДЕЛЕН ФАЙЛ, А НЕ ПРОМЯНА В mila-rezervaciya.js

   Там живее всичко, което РАБОТИ: кой какво прави, цените, капарата,
   свободните часове, касата. Този файл не пипа нищо от това. Той само
   решава какво се вижда в момента, и го прави с едно: скрива стъпките
   СЛЕД текущата. Падне ли, страницата се връща на стария си вид, с
   всичко отворено наведнъж, и продължава да записва часове.

   Затова и скриването е с CSS клас върху <body>, а не с пипане на
   `hidden` по елементите: `hidden` е на mila-rezervaciya.js и двата кода
   щяха да се бият за един и същ атрибут.

   КОЯ СТЪПКА Е ТЕКУЩАТА

   Първата, която я има на страницата и още не е отговорена. Отговорите
   се четат от състоянието, което mila-rezervaciya.js и mila-semeystvo.js
   вече поддържат, а не се пазят втори път тук. Два източника на истината
   за един и същ въпрос е как се раждат дефектите „цял ден се опитвам и
   само ме върти на едно и също".

   НАЗАД СЕ ВРЪЩА БЕЗ БУТОН „НАЗАД"

   Отговорената стъпка се свива сама до един ред с „смени" — денят и
   часът го правеха и досега, а „при кого" се свива до главата на
   списъка. Тези редове стоят НАД текущата стъпка и всеки се цъка. Това
   е и навигацията назад: нищо ново за научаване, и няма второ състояние,
   което да се разминава с истинското.
*/
(function(){
'use strict';

function $(id){ return document.getElementById(id); }

// ─── Кои са стъпките ─────────────────────────────────────────────────
//
// `id` са елементите, които принадлежат на стъпката: по тях се решава
// какво да се скрие, когато стъпката е още напред.
// `ima` казва дали стъпката изобщо съществува на тази страница: на
// лазера няма чипове, при повечето процедури няма снимка.
// `ok` казва дали е отговорена.
var СТЪПКИ = [
  { k:'usluga', z:'Коя процедура', id:['zap-izbor'],
    ima:function(){ return !!$('zap-izbor'); },
    ok:function(){ var р = $('zap-red-usluga'); return !!(р && !р.hidden); } },

  // Лазерът. Зоните решават и цената, и траенето, затова вървят ПРЕДИ
  // всичко останало. Останат ли извън екрана (те се рисуват от
  // mila-lazer.js, в отделен блок над чиповете), жената натиска „Запази
  // час" и се озовава пред календар за нула зони.
  { k:'zoni', z:'Кои зони', id:['laz-vgraden'],
    ima:function(){ return !!$('laz-vgraden'); },
    // Зоните са МНОГОКРАТЕН избор: първата избрана зона не значи, че е
    // готова. Затова стъпката се смята за минала чак когато зоните са
    // ПРИЛОЖЕНИ с „Готово".
    //
    // Антонио, 25.10.2026: „на лазерната, след като избера определена
    // зона, след това няма бутон, за да се продължи напред." Бутонът го
    // има, но е на дъното на отворения списък със зони и се губи. Сега
    // количката с него е залепена долу (виж mila.css), а стъпката чака
    // него, не първата зона.
    ok:function(){ return ЗОНИ_ГОТОВИ && имаИзбраниЗони(); } },

  { k:'nivo', z:'Какво ти трябва', id:['sem-izbori'],
    ima:function(){ var е = $('sem-izbori'); return !!(е && !е.hidden && е.innerHTML.trim()); },
    // Класът го слага mila-semeystvo.js и го маха в мига, в който жената
    // избере чип. Няма го класът — значи е избрала.
    ok:function(){ return !document.body.classList.contains('sem-bez-izbor'); } },

  { k:'hora', z:'При кого', id:['usl-hora'],
    // Тук не стига „елементът го има". На лазера той Е в страницата, но
    // стар стил го крие: `.laz-stranica #usl-hora{display:none}`, защото
    // лазерът е винаги при Грета и избор няма. Питаме ли само за
    // съществуване, екранът обявява „Стъпка 2 от 5 · При кого" и показва
    // празно. Антонио го видя на 25.10.2026 на цяло тяло.
    ima:function(){ return видим($('usl-hora')); },
    // Тук НЕ питаме кой е отметнат: по подразбиране винаги има отметнат
    // ред (първият без капаро). Питаме дали ЖЕНАТА е натиснала. Точно
    // това разминаване е причината една клиентка да напише „никъде не
    // пишело Мила": избрана беше Грета, без тя да е избирала.
    ok:function(){ return ИЗБРАЛА_ЧОВЕК || самоЕдин(); } },

  { k:'snimka', z:'Снимка', id:['rez-triazh'],
    ima:function(){ var е = $('rez-triazh'); return !!(е && !е.hidden); },
    ok:function(){ return !document.body.classList.contains('triazh-chaka'); } },

  { k:'den', z:'Кой ден', id:['rez-red-den','rez-dni'],
    ima:function(){ return !!$('rez-dni'); },
    // Свитият ред „понеделник, 12 ноември · смени" се показва само след
    // избран ден. Той е и отговорът, и пътят назад.
    ok:function(){ var р = $('rez-red-den'); return !!(р && !р.hidden); } },

  { k:'chas', z:'Кой час', id:['rez-red-chas','rez-chasove'],
    ima:function(){ return !!$('rez-chasove'); },
    ok:function(){ var р = $('rez-red-chas'); return !!(р && !р.hidden); } },

  // Тази стъпка я има винаги, щом я има в страницата: иначе броят горе
  // подскача от „3 от 5" на „6 от 6" точно накрая, когато човек най-
  // много гледа докъде е стигнал.
  { k:'dannite', z:'Твоите данни', id:['rez-potvardi'],
    ima:function(){ return !!$('rez-potvardi'); },
    ok:function(){ return false; } }
];

// Един човек не е избор: стъпката е отговорена от само себе си.
//
// Първата версия искаше да няма НИТО ЕДИН `[data-hora]`. Грешка, и то
// тиха: в този случай mila-rezervaciya.js рисува реда текст (`.usl-edin`)
// И пази единствения бутон вътре в СВИТИЯ списък, за да не губи данните.
// Бутонът го има, но е скрит. Стъпката чакаше натискане на нещо, което
// жената не вижда, и следващата стъпка не идваше никога.
//
// Намерено на 25.10.2026 при обхода преди пускане, на „Почистване на
// лице". Засягаше всяка процедура с един специалист: терапиите, лазерните
// по зони, пилингът. Антонио беше пробвал микроблейдинга (трима души) и
// лазера (където „При кого" изобщо е скрито) и там не личеше.
function самоЕдин(){
  var к = $('usl-hora');
  if(!к) return false;
  if(к.querySelector('.usl-edin')) return true;
  // И когато списъкът е нормален, но с един ред: пак няма какво да се
  // избира, значи няма и какво да се чака.
  return к.querySelectorAll('[data-hora]').length === 1;
}

var ЗОНИ_ГОТОВИ = false;
function имаИзбраниЗони(){
  var к = $('laz-kolichka');
  return !!(к && !к.hidden);
}
// „Готово" при зоните. Успехът личи по едно нещо: mila-lazer.js затваря
// <details> САМО когато зоните наистина са приложени. Избере ли жената
// зони за повече от два часа и половина, той не ги прилага, а показва
// телефона — и тогава стъпката трябва да си остане тук.
document.addEventListener('click', function(е){
  if(!(е.target.closest && е.target.closest('#laz-napred'))) return;
  after(function(){
    var д = $('laz-vgraden');
    ЗОНИ_ГОТОВИ = !!(д && !д.open) && имаИзбраниЗони();
    пресметни();
  });
}, true);

var ИЗБРАЛА_ЧОВЕК = false;
document.addEventListener('click', function(е){
  var б = е.target.closest && е.target.closest('[data-hora]');
  if(б){ ИЗБРАЛА_ЧОВЕК = true; пресметни(); }
}, true);

// Смени ли се процедурата или нивото, списъкът се рисува наново, с други
// хора и други цени. Дотук това нулираше избора на човек ВИНАГИ.
//
// Антонио, 27.10.2026: „ако влезе примерно с Грета, това да е фиксирано,
// и само да сменят отгоре поддръжка, отдолу да им излизат директно
// датите." И е прав: жена, която вече е казала при кого иска, не бива да
// го казва пак само защото е сменила първична с поддръжка. Дотук трябваше
// да отвори свития ред и да натисне името втори път, за да се появят дни.
//
// Затова човекът пада само ако НОВОТО ниво не го прави. Прави ли го, той
// си остава избран и стъпката „При кого" остава минала.
document.addEventListener('click', function(е){
  var б = е.target.closest && е.target.closest('.sem-chip, [data-otvori="usluga"]');
  if(!б) return;
  // Името се чете ПРЕДИ преначертаването: след него вече е новото.
  var предишен = null;
  try{
    if(typeof window.MILA_KOY_E_IZBRAN === 'function') предишен = window.MILA_KOY_E_IZBRAN();
  }catch(_){}
  var беше = ИЗБРАЛА_ЧОВЕК;
  after(function(){
    ИЗБРАЛА_ЧОВЕК = false;
    if(беше && предишен){
      var к = $('usl-hora');
      if(к) [].forEach.call(к.querySelectorAll('[data-hora]'), function(b){
        if(b.dataset.hora === предишен) ИЗБРАЛА_ЧОВЕК = true;
      });
    }
    пресметни();
  });
}, true);

// ─── Какво се скрива ─────────────────────────────────────────────────
//
// За всяка стъпка едно правило: „когато сме дотук, скрий всичко след
// нея". Правилата се сглобяват от списъка по-горе, за да не изостанат,
// ако утре се добави стъпка.
(function(){
  var правила = [];
  СТЪПКИ.forEach(function(с, i){
    var по = [];
    СТЪПКИ.slice(i + 1).forEach(function(х){ по = по.concat(х.id); });
    if(!по.length) return;
    правила.push(по.map(function(id){
      return 'body.st-do-' + с.k + ' #' + id;
    }).join(',') + '{display:none!important}');
  });
  var ст = document.createElement('style');
  ст.textContent = правила.join('\n');
  document.head.appendChild(ст);
})();

// Кутията за снимка се ражда в mila-rezervaciya.js и се вмъква до
// „при кого". Само че тя се ражда РАНО, още при първото пресмятане на
// цената, а екранът се сглобява по-късно: тогава „при кого" заминава в
// екрана, а кутията остава на старото си място, зад него.
//
// Резултатът, видян от Антонио на 25.10.2026: горе пише „Стъпка 3 от 5 ·
// Снимка", а отдолу няма нищо. Жената стига дотам и спира.
//
// Затова всеки път се проверява къде седи и се връща до „при кого".
// Поправя се само, независимо кой кога се е създал.
function подредиТриажа(){
  доДо($('rez-triazh'), $('usl-hora'));
  // Подканата „Избери … отгоре, за да видиш свободните часове" я прави
  // mila-semeystvo.js и я закача до чиповете. Пак рано, пак преди
  // екрана: на снимката на Антонио от 25.10.2026 тя стоеше на самата
  // страница, над бутона, а чиповете вече бяха вътре в екрана. Жената
  // чете „избери отгоре", а отгоре няма нищо.
  доДо($('sem-podkana'), $('sem-izbori'));
}

// Слага `кой` веднага след `след`, ако вече не е там.
function доДо(кой, след){
  if(!кой || !след || !след.parentNode) return;
  if(кой.previousElementSibling === след) return;
  след.parentNode.insertBefore(кой, след.nextSibling);
}

// Вижда ли се изобщо. Нула размери значи скрито, независимо от кое
// правило: `display:none`, `hidden`, нулев родител.
function видим(е){
  return !!(е && (е.offsetWidth || е.offsetHeight || е.getClientRects().length));
}

var ТЕКУЩА = null;

function пресметни(){
  подредиТриажа();
  // Затворен екран: всичко вътре е с нулев размер и всяко мерене лъже.
  // Отварянето вика пресметни() наново.
  var екр = $('st-ekran');
  if(екр && екр.hidden) return;

  // Мери се БЕЗ нашите класове. Инак се питаме дали нещо се вижда,
  // докато сами го крием, и отговорът е винаги „не": стъпката, която
  // чака реда си, изглежда несъществуваща и никога не идва.
  // Махането и слагането стават в един и същ тик, затова не мига.
  //
  // Наблюдателят спира, докато пипаме класовете. Той слуша точно класа
  // на <body>, а ние го сменяме: без това всяко пресмятане си поръчва
  // следващо и цикълът не свършва никога. Хванато на 25.10.2026, когато
  // пробата увисна — в браузъра същото щеше да изяде телефона мълчаливо.
  // `disconnect()` изхвърля и вече натрупаните записи, затова спирането
  // и пускането в един и същ синхронен блок е достатъчно.
  сприНаблюдателя();
  СТЪПКИ.forEach(function(с){ document.body.classList.remove('st-do-' + с.k); });
  var редът = СТЪПКИ.filter(function(с){ return с.ima(); });
  var сега = null;
  for(var i = 0; i < редът.length; i++){
    if(!редът[i].ok()){ сега = редът[i]; break; }
  }
  // Всичко е отговорено: последната стъпка („Твоите данни") остава на
  // екрана. Няма такава стъпка — значи няма какво да се води.
  if(!сега) сега = редът[редът.length - 1] || null;

  СТЪПКИ.forEach(function(с){
    document.body.classList.toggle('st-do-' + с.k, !!сега && с.k === сега.k);
  });
  пусниНаблюдателя();

  надпис(сега, редът);
  // Пристигне ли се на зоните, списъкът се отваря сам веднъж: свит, той
  // е само ред „Зони · избери" и жената не вижда какво се иска от нея.
  // Веднъж, не всеки път, за да може да го затвори, ако реши.
  if(сега && сега.k === 'zoni' && ТЕКУЩА !== 'zoni'){
    var д = $('laz-vgraden');
    if(д && !д.open) д.open = true;
  }
  ТЕКУЩА = сега ? сега.k : null;
}

// ─── Главата: коя стъпка е това и колко са всичко ────────────────────
function надпис(сега, редът){
  var г = $('st-glava');
  if(!г || !сега) return;
  var н = редът.indexOf(сега) + 1;
  г.innerHTML =
    '<span class="st-broi">Стъпка ' + н + ' от ' + редът.length + '</span>' +
    '<b class="st-zaglavie">' + сега.z + '</b>' +
    '<span class="st-lenta"><i style="width:' +
      Math.round(н / редът.length * 100) + '%"></i></span>';
}

// ─── Екранът на процедурната страница ────────────────────────────────
//
// Антонио: „когато дойдат на сайта за процедурата, просто да има един
// бутон Запази час, и оттам да ги питаме."
//
// Дотук целият избор стоеше насред страницата, между разказа за
// процедурата и въпросите. Жената скролва, подминава го, връща се.
// Сега разказът остава както си е (той вади хората от рекламите), а
// изборът живее в екран, който се отваря с бутона и се затваря с Х.
//
// На „Запази час" екран НЕ се прави: там цялата страница е това.
function екран(){
  var лента = $('usl-lenta-cta');
  var хора = $('usl-hora');
  var рез = $('rez');
  if(!лента || !хора || !рез) return;        // не сме на процедурна страница

  var е = document.createElement('div');
  е.id = 'st-ekran';
  е.className = 'st-ekran';
  е.hidden = true;
  е.innerHTML =
    '<div class="st-fon" data-st="zatvori"></div>' +
    '<div class="st-kutiya" role="dialog" aria-modal="true" aria-label="Запазване на час">' +
      '<div class="st-shapka">' +
        '<div id="st-glava" class="st-glava"></div>' +
        '<button type="button" class="st-x" data-st="zatvori" aria-label="Затвори">×</button>' +
      '</div>' +
      '<div class="st-tyalo" id="st-tyalo"></div>' +
    '</div>';
  document.body.appendChild(е);
  // Казва на CSS-а, че екранът го има: подканата от mila-semeystvo.js
  // вече е излишна, защото главата горе сама пише коя е стъпката и
  // какво се иска. Две подкани за едно нещо е шум, а целта е „супер
  // просто".
  document.body.classList.add('st-ima-ekran');

  // Бутонът, който отваря екрана, застава ТАМ, където досега беше
  // изборът. Антонио: „просто да има един бутон Запази час."
  //
  // Лепкавата лента долу не върши тази работа сама: тя е само за
  // телефон (`.usl-lenta{display:none}` над 860 пиксела). Останеше ли
  // тя единственият вход, на компютър изборът изчезва в затворен екран
  // и човек просто не може да запази час.
  var пуск = document.createElement('div');
  пуск.className = 'st-pusk';
  пуск.innerHTML =
    '<button type="button" class="mila-btn pln st-pusk-btn" data-st="otvori">' +
      'Запази час</button>';
  хора.parentNode.insertBefore(пуск, хора);

  var тяло = $('st-tyalo');
  // Местят се самите елементи, не копия: вътре в тях вече висят
  // слушатели и състояние. Копие щеше да изглежда същото и да не работи.
  var зони = $('laz-vgraden');
  if(зони) тяло.appendChild(зони);
  var чипове = $('sem-izbori');
  if(чипове) тяло.appendChild(чипове);
  тяло.appendChild(хора);
  тяло.appendChild(рез);
  подредиТриажа();

  // Долната лепкава лента излиза само когато горният бутон е излязъл от
  // екрана. Антонио, 25.10.2026: „този бутон да излиза само когато
  // горният е скрит и не е на самия екран, иначе стават 2 бутона."
  //
  // Същото правило вече важи за бутона за плащане в самата секция: там
  // лентата се скрива, когато истинският бутон се вижда. Тук е същата
  // мисъл, само за другия край на страницата.
  следиБутона(пуск.querySelector('.st-pusk-btn'));

  лента.addEventListener('click', function(ев){ ев.preventDefault(); отвори(true); });
  document.addEventListener('click', function(ев){
    if(!ев.target.closest) return;
    if(ев.target.closest('[data-st="otvori"]')){ ев.preventDefault(); отвори(true); return; }
    if(ев.target.closest('[data-st="zatvori"]')){ ев.preventDefault(); отвори(false); }
  });
  document.addEventListener('keydown', function(ев){
    if(ев.key === 'Escape' && !е.hidden) отвори(false);
  });
}

// Вижда ли се горният бутон: докато е на екрана, долната лента е излишна.
// IntersectionObserver, а не слушане на скролване: браузърът го смята сам,
// без да мери височини при всяко движение на пръста.
function следиБутона(б){
  if(!б) return;
  if(!window.IntersectionObserver){
    // Стар браузър: по-добре лентата да стои, отколкото да няма бутон.
    document.body.classList.remove('st-pusk-vidim');
    return;
  }
  new IntersectionObserver(function(записи){
    записи.forEach(function(з){
      document.body.classList.toggle('st-pusk-vidim', з.isIntersecting);
    });
  }, {rootMargin: '-10px 0px -10px 0px'}).observe(б);
}

function отвори(да){
  var е = $('st-ekran');
  if(!е) return;
  е.hidden = !да;
  document.body.classList.toggle('st-otvoren', да);
  if(да){ пресметни(); var т = $('st-tyalo'); if(т) т.scrollTop = 0; }
}

// ─── Кога се преглежда наново ────────────────────────────────────────
//
// Всичко, което сменя стъпка, минава през `hidden` или през клас на
// <body>: свиването на деня, появата на снимката, показването на
// сметката. Затова се гледат точно те, вместо да се пипа чуждият код.
function after(f){ setTimeout(f, 0); }

var НАБЛЮДАТЕЛ = null;
function пусниНаблюдателя(){
  if(!НАБЛЮДАТЕЛ) return;
  НАБЛЮДАТЕЛ.observe(document.body, {attributes:true, attributeFilter:['class']});
  ['sem-izbori','usl-hora','rez-dni','rez-chasove','rez-red-den','rez-red-chas',
   'rez-potvardi','zap-red-usluga','rez','laz-kolichka','laz-vgraden'].forEach(function(ид){
    var е = $(ид);
    if(е) НАБЛЮДАТЕЛ.observe(е, {attributes:true, attributeFilter:['hidden','open'],
                                 childList:true, subtree:true});
  });
  // Кутията за снимка се ражда по-късно, затова се следи родителят ѝ.
  var р = ($('usl-hora') || {}).parentNode;
  if(р) НАБЛЮДАТЕЛ.observe(р, {childList:true});
}
function сприНаблюдателя(){ if(НАБЛЮДАТЕЛ) НАБЛЮДАТЕЛ.disconnect(); }

function следи(){
  НАБЛЮДАТЕЛ = new MutationObserver(function(){ after(пресметни); });
  пусниНаблюдателя();
}

function почни(){
  екран();
  следи();
  пресметни();
}

if(document.readyState === 'loading')
  document.addEventListener('DOMContentLoaded', почни);
else почни();

})();
